import React, { useEffect, useState } from 'react'
import { Send } from 'lucide-react'

export default function OnlineClass() {
    const [email, setEmail] = useState('')
    const [isSubscribed, setIsSubscribed] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const handleSubscribe = (e) => {
        e.preventDefault()
        // Simulate API call
        setIsSubscribed(true)
        setTimeout(() => setIsSubscribed(false), 5000)
        setEmail('')
    }

    const roadmap = [
        {
            phase: "Phase 01",
            title: "Digital Infrastructure",
            status: "Completed",
            desc: "Setting up high-speed dedicated servers and secure streaming protocols for uninterrupted learning."
        },
        {
            phase: "Phase 02",
            title: "Curriculum Digitization",
            status: "In Progress",
            desc: "Adapting our time-tested scholastic syllabi into interactive, high-definition digital modules."
        },
        {
            phase: "Phase 03",
            title: "Beta Experience",
            status: "Upcoming",
            desc: "Granting exclusive access to a selected group of seekers for real-world platform testing."
        },
        {
            phase: "Phase 04",
            title: "Global Launch",
            status: "Vision",
            desc: "Opening the doors of our digital sanctuary to the worldwide community of knowledge seekers."
        }
    ]

    return (
        <div className="min-h-screen bg-white text-gray-900 pb-24">
            <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto text-center relative">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-secondary/10 rounded-full blur-3xl pointer-events-none"></div>
                <span className="text-xs tracking-widest uppercase text-secondary font-bold mb-6 block relative z-10">Knowledge Horizon</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8 relative z-10">
                    Sacred <span className="font-medium text-secondary">Digital Gateway</span>.
                </h1>
                <p className="text-lg md:text-xl text-gray-600 font-light max-w-2xl mx-auto leading-relaxed relative z-10">
                    We are meticulously curating a world-class virtual sanctuary where classical wisdom meets next-generation technology.
                </p>
            </section>

            <section className="py-16 px-6 max-w-3xl mx-auto">
                <div className="bg-primary text-white rounded-[40px] p-10 md:p-16 text-center shadow-2xl relative overflow-hidden">
                    <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-secondary/20 rounded-full blur-2xl"></div>
                    
                    <h3 className="text-3xl font-light text-white mb-6 relative z-10">Claim Your Priority Token</h3>
                    <p className="text-white/70 font-light mb-12 relative z-10">
                        Be the first to step into the digital frontiers of Madrasa Faiz Ul Hasnain. Joining the waitlist grants you exclusive early-access.
                    </p>

                    <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto relative z-10">
                        <input 
                            type="email" 
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="flex-1 bg-white/10 border border-white/20 rounded-2xl py-4 px-6 text-sm text-white placeholder-white/50 focus:border-secondary outline-none transition-colors backdrop-blur-sm"
                            required
                        />
                        <button 
                            type="submit"
                            className="px-8 py-4 bg-secondary text-white font-bold rounded-2xl text-xs tracking-widest uppercase hover:bg-yellow-500 transition-colors shadow-lg active:scale-95 flex items-center justify-center gap-3"
                        >
                            <Send className="w-4 h-4" />
                            Notify Me
                        </button>
                    </form>

                    {isSubscribed && (
                        <div className="mt-8 text-xs text-secondary font-bold uppercase tracking-widest relative z-10 animate-fade-in-up">
                            JazakAllah! Your token has been reserved.
                        </div>
                    )}
                </div>
            </section>

            <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto border-t border-gray-100 mt-12">
                <div className="mb-16 text-center">
                    <span className="text-xs tracking-widest uppercase text-secondary font-bold mb-4 block">The Genesis Roadmap</span>
                    <h2 className="text-3xl font-light text-primary">Strategic Evolution.</h2>
                    <div className="w-12 h-px bg-secondary mx-auto mt-6"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {roadmap.map((step, idx) => (
                        <div key={idx} className="flex flex-col bg-gray-50 border border-gray-100 rounded-3xl p-8 hover:border-primary/20 hover:shadow-md transition-all group">
                            <span className="text-[10px] uppercase tracking-widest font-bold text-secondary mb-4 block">{step.phase}</span>
                            <h4 className="text-xl font-medium text-primary mb-4">{step.title}</h4>
                            <p className="text-gray-500 font-light text-sm leading-relaxed mb-8 flex-1">{step.desc}</p>
                            
                            <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-200">
                                <div className={`w-2.5 h-2.5 rounded-full ${step.status === 'Completed' ? 'bg-primary' : step.status === 'In Progress' ? 'bg-secondary animate-pulse' : 'bg-gray-300'}`}></div>
                                <span className="text-[10px] font-bold uppercase tracking-widest text-primary">{step.status}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}
